import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains GL Expense Entry: A financial record documenting expenses within the institution’s general ledger system.',
    name: 'GL Expense',
    partialId: PartialId.Standard.create('gl_exp'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
